const getList = response => {
    const bind = [];
    const itemLength = response.resultSet.totalResult;
    if (itemLength > 0) {
        bind.push({
            devicename: response.resultSet.ssid,
            displayname: response.resultSet.ssid,
            ipaddress: response.resultSet.ipaddress,
            serialnumber: response.resultSet.serialnumber,
            comment: ' ',
        })
    }
    return bind;
};

const initialState = {
    category: undefined,
    bind: undefined,
    serialnumber:undefined,
    devicename:undefined,
    error: false
};

export default(state = initialState, action) => {
    switch(action.type){
        case 'START_REQUEST':
            return {
                category: action.payload.category,
                bind: undefined,
                error: false
            };
        case 'RECEIVE_DATA':
            return action.payload.error
            ?{...state,error:true}
            :{
                ...state,
                bind: getList(action.payload.response)
            };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/ThetaDetecting.js